import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getConnections(filterBy, view, currUserId, pagination = {}) {
        const url = `${config.cloudFunctionsBaseUrl}/getConnections`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy),
            search: pagination.search,
            page: pagination.page,
            pageSize: pagination.pageSize,
        });
    },
}